module.exports = __webpack_public_path__ + "img/handshake-simple-slash.119eaf4b.svg";